import axios from '../axios';
import { createTypes } from "./createTypes";
import createAction from "./createAction";
import API from "./api";
import * as types from "./types";

const baseUrl = `${API}/user/phone-number/`;

export function getUserPhoneNumber() {
  return async dispatch => { 
    try {
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).loading, true))
      const { data } = await axios.get(`${baseUrl}get/`);
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).success, data))
      return data;
    } catch(error) {
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).error, error))
      throw error;
    } finally {
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).loading, false))
    }
  }
}

export function updateUserPhoneNumber(payload) {
  return async dispatch => { 
    try {
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).loading, true))
      const { data } = await axios.patch(`${baseUrl}`, payload);
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).success, data))
      return data;
    } catch(error) {
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).error, error))
      throw error;
    } finally {
      dispatch(createAction(createTypes(types.USER_PHONE_NUMBER).loading, false))
    }
  }
}